import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "@/components/ThemeProvider";

export const Logo = ({ className = "", invert = false }) => {
  const { theme } = useTheme();
  const effectiveInvert = invert || theme === "dark";
  const inkColor = effectiveInvert ? "#FFFFFF" : "#09090B";
  const brand = effectiveInvert ? "#7C9BFF" : "#002FA7";
  return (
    <Link
      to="/"
      data-testid="brand-logo"
      className={`group inline-flex items-center gap-2.5 select-none ${className}`}
    >
      {/* Mark */}
      <span
        aria-hidden
        className="relative inline-flex items-center justify-center"
      >
        <svg width="30" height="30" viewBox="0 0 32 32" fill="none">
          <rect
            x="1"
            y="1"
            width="30"
            height="30"
            rx="3"
            stroke={inkColor}
            strokeWidth="1.5"
          />
          <circle cx="16" cy="16" r="6.5" fill={brand} />
          <circle
            cx="16"
            cy="16"
            r="10.5"
            stroke={brand}
            strokeWidth="1.25"
            strokeDasharray="2 3"
            opacity="0.6"
          />
        </svg>
      </span>
      {/* Wordmark */}
      <span
        className="font-display font-black tracking-tighter text-[1.35rem] leading-none"
        style={{ color: inkColor }}
      >
        Jai<span style={{ color: brand }}>sphere</span>
      </span>
    </Link>
  );
};

export default Logo;